import React from "react";

import arrowLeft from "../../../../assets/img/arrow_left.svg";
import { SVGGraphColumnNavProps } from "./SVGGraphColumnNavTypes";
import { useSVGGraphColumnNavAvailability } from "./useSVGGraphColumnNavAvailability";

const btnClassName = (enabled: boolean) =>
  `w-[2.125rem] h-[1.25rem] select-none items-center justify-center flex rounded-sm border-0 p-0 ${
    enabled
      ? "bg-arrow-btn cursor-pointer"
      : "bg-disabled-btn pointer-events-none"
  }`;

const SVGGraphColumnNav = ({
  dataType,
  subtitle,
  changeCounter,
  allStatsData,
  currentYear,
  currentMonth,
  counter,
  deltaCounter,
  className,
}: SVGGraphColumnNavProps) => {
  const { hasPrevData, hasNextData } = useSVGGraphColumnNavAvailability({
    dataType,
    allStatsData,
    currentYear,
    currentMonth,
    counter,
    deltaCounter,
  });

  const canGoPrev = hasPrevData && !!changeCounter;
  const canGoNext = hasNextData && !!changeCounter;

  return (
    <div
      data-testid={`${dataType}-nav`}
      className={`mx-auto max-w-xl text-center text_8c8c8c flex justify-center items-center${
        className ? ` ${className}` : ""
      }`}
    >
      <button
        type="button"
        data-testid="svg-graph-column-nav-prev"
        className={btnClassName(canGoPrev)}
        disabled={!canGoPrev}
        onClick={() => changeCounter?.(-1)}
        aria-label="Previous period"
      >
        <img height={9} width={5} src={arrowLeft} alt="" />
      </button>
      <div className="w-36 select-none font-bold text-sm leading-none text-center text-gray-label">
        {subtitle ? subtitle : ""}
      </div>
      <button
        type="button"
        data-testid="svg-graph-column-nav-next"
        className={btnClassName(canGoNext)}
        disabled={!canGoNext}
        onClick={() => changeCounter?.(1)}
        aria-label="Next period"
      >
        <img
          height={9}
          width={5}
          src={arrowLeft}
          alt=""
          className="rotate-180"
        />
      </button>
    </div>
  );
};

export default SVGGraphColumnNav;
